"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.pass_reset.subject': 'Password Reset Request',
    'email.pass_reset.title': 'Reset Your Password',
    'email.pass_reset.text': 'You have requested to reset your password. Click the button below to set a new password.',
    'email.pass_reset.button': 'Reset Password',
};
